module.exports = __webpack_public_path__ + "static/media/dhl.a2e28745.png";